module.exports = __webpack_public_path__ + "static/img/img_0.d473c88.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/img_0.png
// module id = f1hg
// module chunks = 0